/* import __COLOCATED_TEMPLATE__ from './ignored-user-list-item.hbs'; */
import Component from "@ember/component";
export default Component.extend({
  tagName: "div",
  items: null,
  actions: {
    removeIgnoredUser(item) {
      this.onRemoveIgnoredUser(item);
    },
  },
});
